import Backbone from 'backbone'
import UserBasicsForm from './user-basics-form'
import _ from 'lodash'
import logout from './logout.hbs'
import template from './account-info.hbs'
import formHelper from 'scoreboard/components/form-helper'
import DisplayHeader from 'scoreboard/components/display-header'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import permissions from 'scoreboard/components/permissions'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'

/**
 * The Admin | Account Info screen.
 */
var AccountInfo = Backbone.View.extend({

	// this.model is the currently logged in user

	tagName: 'form',

	className: 'admin account-info display-layout table-hack',

	events: {
		'click .logout': 'logout',
		'click .cancel': 'cancel'
	},

	initialize: function() {
		this.formView = new FormView({
			el: this.el,
			toggleCancel: true,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.userBasicsForm = new UserBasicsForm({
			model: this.model,
			hideId: true,
			isPanel: true
		})
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.personal.accountInfo'),
			mobileGearHidden: true
		}).render().el, template())
		this.$('.user-basics-form').append(this.userBasicsForm.el)
		this.userBasicsForm.render()
		this.$('.main-header').removeClass('is-not-displayed')
		this.$('.right-buttons').append(logout())

		this.formView.start()

		this.secure()

		return this
	},

	// Remove save/cancel button if current user is built in "admin" or a user who cannot edit account info. Issue #4589
	secure: function() {
		var adminReadOnly = this.model.get('username') === 'admin'
		if (adminReadOnly) {
			this.$('.user-basics-form').addClass('admin-read-only')
		}

		if (adminReadOnly || !permissions.personalAccountInfo()) {
			this.$('.sticky-footer').remove()
		}
	},

	logout: function() {
		location.href = scoreboardUrl('logout')
	},

	cancel: function() {
		this.userBasicsForm.cancel()
		this.formView.start()
	},

	submit: function(e) {
		var data = formHelper.readFromDom(this.el)
		return this.model.save(data, {
			success: function() {
				this.formView.start()
			}.bind(this),
			error: function(model, xhr) {
				this.formView.error(xhr)
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.userBasicsForm, this.confirmPasswordField], 'remove')
	}

})

export default AccountInfo

AccountInfo.__filename__ = 'admin/principals/users/account-info.js'
